<template>
  <div class="form5-container">
    <el-form
      :model="form"
      label-width="auto"
      label-position="top"
      :rules="rules"
      ref="ruleForm"
      status-icon
      class="custom-form"
    >
      <!-- 自定义地图模式 -->
      <el-form-item
        label="自定义地图（双击添加或消除）"
        v-if="dataForm2 && dataForm2.mapSelect === '自定义地图'"
      >
        <CustomeMap class="map-view" ref="CavMap"></CustomeMap>
      </el-form-item>

      <!-- 经纬度与地图拾取 -->
      <el-form-item label="地理坐标（经纬度）">
        <div class="coord-group">
          <div class="coord-input-item">
            <span class="coord-label">纬度 Lat</span>
            <el-input v-model="form.lat" placeholder="0.000000" clearable />
          </div>
          <div class="coord-input-item">
            <span class="coord-label">经度 Lng</span>
            <el-input v-model="form.lng" placeholder="0.000000" clearable />
          </div>
          <el-button
            type="primary"
            class="map-picker-btn"
            @click="isShow = true"
          >
            <el-icon><LocationInformation /></el-icon>
            打开地图拾取
          </el-button>
        </div>
      </el-form-item>

      <el-form-item label="地点名称" prop="address">
        <el-input
          v-model="form.address"
          placeholder="请输入详细地点或标志性建筑名称"
        />
      </el-form-item>

      <!-- 分割标题栏 -->
      <div class="section-divider">
        <span class="section-title">关卡位置提示</span>
        <span class="section-subtitle">配置引导玩家寻找此地点的线索内容</span>
      </div>

      <el-form-item label="地点提示标题">
        <el-input
          v-model="form.addressTipName"
          placeholder="例如：古桥旁的石碑"
        />
      </el-form-item>

      <el-form-item label="地点提示内容">
        <el-input
          v-model="form.addressTipContent"
          type="textarea"
          :rows="4"
          placeholder="详细描述如何找到目标地点..."
        />
      </el-form-item>

      <el-form-item label="关卡位置提示图（支持拖拽排序，最多5张）">
        <div class="upload-gallery-container">
          <VueDraggable
            ref="el"
            v-model="fileList2"
            class="draggable-image-list"
            :animation="150"
          >
            <div
              v-for="(item, index) in fileList2"
              :key="item.uid || index"
              class="image-item-card"
            >
              <el-image :src="item.url" fit="cover" class="thumb-img" />
              <div class="image-mask">
                <span
                  class="del-btn"
                  @click.stop="clearImage2(index)"
                  title="删除图片"
                >
                  <el-icon><Delete /></el-icon>
                </span>
              </div>
            </div>
          </VueDraggable>

          <el-upload
            v-if="fileList2.length < 5"
            :file-list="fileList2"
            :action="UpdateApi"
            :on-success="handleAvatarSuccess2"
            :before-upload="beforeAvatarUpload2"
            :show-file-list="false"
            list-type="picture-card"
            class="custom-uploader-card"
          >
            <el-icon class="uploader-icon"><Plus /></el-icon>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>

    <!-- 地图选择弹窗 -->
    <Map
      :isShow="isShow"
      @onMapClose="handleCloseMap"
      @onSubmit="handleSubmit"
    ></Map>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from "vue";
import { Plus, Delete, LocationInformation } from "@element-plus/icons-vue";
import { ElNotification, FormRules, UploadProps } from "element-plus";
import MapContainer from "@/components/content/MapContainer.vue";
import Map from "@/components/map/index.vue";
import { VueDraggable } from "vue-draggable-plus";
import CustomeMap from "@/components/canvans/CustomeMap.vue";

const validateNotEmpty = (rule: any, value: string, callback: any) => {
  if (!value || value.trim() === "") {
    callback(new Error(rule.message));
  } else {
    callback();
  }
};

export default defineComponent({
  name: "LocationForm",
  components: {
    VueDraggable,
    Map,
    MapContainer,
    Plus,
    Delete,
    LocationInformation,
    CustomeMap,
  },
  props: ["dataForm", "dataForm2"],
  data(): any {
    return {
      form: {
        addressTipName: "",
        address: "",
        lat: 0,
        lng: 0,
        tipCover: "",
        addressTipContent: "",
      },
      fileList2: [],
      isShow: false,
      rules: reactive<FormRules>({
        address: [
          {
            required: true,
            message: "地点名称不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
      }),
    };
  },
  computed: {
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  watch: {
    fileList2: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.form.tipCover = newVal.map((item: any) => item.url).join(",");
        } else {
          this.form.tipCover = "";
        }
      },
      deep: true,
    },
    dataForm: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.updateForm(newVal);
        }
      },
    },
    dataForm2: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.updateMap(newVal);
        }
      },
    },
  },
  methods: {
    updateForm(dataForm: any) {
      this.form.addressTipName = dataForm.addressTipName || "";
      this.form.address = dataForm.address || "";
      this.form.lat = dataForm.lat || 0;
      this.form.lng = dataForm.lng || 0;
      this.form.tipCover = dataForm.tipCover || "";
      this.form.addressTipContent = dataForm.addressTipContent || "";

      if (dataForm.tipCover) {
        this.fileList2 = dataForm.tipCover
          .split(",")
          .map((url: string, index: number) => ({
            url,
            uid: `${Date.now()}_${index}`,
            name: `img_${index}`,
          }));
      } else {
        this.fileList2 = [];
      }
    },
    updateMap(dataForm2: any) {
      this.$nextTick(() => {
        const CavMap: any = this.$refs.CavMap;
        if (CavMap && dataForm2.customizeMap) {
          CavMap.setMap(dataForm2.customizeMap);
        }
      });
    },
    async clearImage2(index: number) {
      // 1. 边界检查
      if (index < 0 || index >= this.fileList2.length) return;

      const target = this.fileList2[index];
      // 2. 提取文件名或路径（兼容常见结构：字符串、{ url } 或 { name }）
      const fileName =
        typeof target === "string" ? target : target?.url || target?.name;

      try {
        // 3. 如果已有远端文件记录，先调用接口删除
        if (fileName) {
          await this.$store.dispatch("user/delFile", {
            fileName,
          });
          ElNotification.success("删除成功");
        }
        // 4. 从列表中移除该项
        this.fileList2.splice(index, 1);
      } catch (error) {
        console.error("删除图片失败:", error);
        ElNotification.error("删除失败");
      }
    },
    handleAvatarSuccess2(response: any) {
      if (response && response.code === 200) {
        this.fileList2.push({
          url: response.data.returnFileUrl,
          uid: Date.now(),
          name: "uploaded_img",
          status: "finished",
        });
      }
    },
    beforeAvatarUpload2(file: File) {
      const isAllowedFormat =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/webp";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isAllowedFormat) {
        ElNotification.warning({
          message: "仅支持 JPG/PNG/WEBP 格式图片",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt5M) {
        ElNotification.warning({
          message: "图片体积不可超过 5MB",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      return this.fileList2.length < 5;
    },
    handleCloseMap() {
      this.isShow = false;
    },
    handleSubmit(coord: string, keyword: string) {
      if (coord) {
        const parts = coord.split(",");
        this.form.lat = parseFloat(parts[0]);
        this.form.lng = parseFloat(parts[1]);
      }
      if (keyword) {
        this.form.address = keyword;
      }
      this.isShow = false;
    },
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-light: #f0f2ff;
@text-main: #1e293b;
@text-sub: #64748b;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@danger-color: #ef4444;

.form5-container {
  width: 100%;
  max-width: 860px;
  margin: 0 auto;

  .custom-form {
    :deep(.el-form-item) {
      margin-bottom: 22px;

      .el-form-item__label {
        font-size: 13.5px;
        font-weight: 600;
        color: @text-main;
        padding-bottom: 6px;
      }
    }

    :deep(.el-input__wrapper),
    :deep(.el-textarea__inner) {
      border-radius: 8px;
      box-shadow: 0 0 0 1px @border-color inset;
      transition: all 0.2s ease;

      &:hover {
        box-shadow: 0 0 0 1px #cbd5e1 inset;
      }

      &.is-focus,
      &:focus {
        box-shadow: 0 0 0 1px @primary-color inset !important;
      }
    }
  }
}

// 经纬度输入行
.coord-group {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  width: 100%;

  .coord-input-item {
    flex: 1;

    .coord-label {
      display: block;
      font-size: 11.5px;
      font-weight: 500;
      color: @text-muted;
      margin-bottom: 4px;
    }
  }

  .map-picker-btn {
    height: 40px;
    padding: 0 18px;
    border-radius: 8px;
    background-color: @primary-light;
    border-color: #dce2ff;
    color: @primary-color;
    font-weight: 600;
    transition: all 0.2s ease;

    .el-icon {
      margin-right: 6px;
      font-size: 15px;
    }

    &:hover {
      background-color: @primary-color;
      border-color: @primary-color;
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(93, 95, 239, 0.25);
    }
  }
}

// 分割标题栏
.section-divider {
  margin: 32px 0 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid @border-color;
  display: flex;
  align-items: baseline;
  gap: 12px;

  .section-title {
    font-size: 16px;
    font-weight: 700;
    color: @text-main;
  }

  .section-subtitle {
    font-size: 12px;
    color: @text-muted;
  }
}

// 图片列表与上传区
.upload-gallery-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  .draggable-image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .image-item-card {
    width: 108px;
    height: 108px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    border: 1px solid @border-color;
    cursor: grab;
    background: #f8fafc;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);

    &:active {
      cursor: grabbing;
    }

    .thumb-img {
      width: 100%;
      height: 100%;
      display: block;
    }

    // 悬停遮罩与删除图标
    .image-mask {
      position: absolute;
      inset: 0;
      background: rgba(15, 23, 42, 0.55);
      backdrop-filter: blur(2px);
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0;
      transition: opacity 0.25s ease;

      .del-btn {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.9);
        color: @danger-color;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: transform 0.2s, background-color 0.2s;

        &:hover {
          background: #ffffff;
          transform: scale(1.15);
        }
      }
    }

    &:hover .image-mask {
      opacity: 1;
    }
  }

  // 穿透覆盖 Element Plus picture-card 样式
  :deep(.custom-uploader-card) {
    .el-upload--picture-card {
      width: 108px;
      height: 108px;
      border-radius: 10px;
      border: 1.5px dashed #cbd5e1;
      background-color: #f8fafc;
      transition: all 0.2s ease;

      &:hover {
        border-color: @primary-color;
        background-color: @primary-light;

        .uploader-icon {
          color: @primary-color;
          transform: scale(1.15);
        }
      }
    }

    .uploader-icon {
      font-size: 22px;
      color: @text-muted;
      transition: all 0.2s ease;
    }
  }
}

.map-view {
  width: 100%;
  height: 400px;
  border-radius: 10px;
  border: 1px solid @border-color;
  overflow: hidden;
}

@media screen and (max-width: 640px) {
  .coord-group {
    flex-direction: column;
    align-items: stretch;

    .map-picker-btn {
      width: 100%;
    }
  }
}
</style>
